import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import alertActions from '../../../sidebar/actions/alert';

import './index.scss';

const styles = bemGenerator('pre-release-information', ['badge']);

class PreReleaseInformation extends React.PureComponent {
  render() {
    const { props, context, history } = this;
    const { t, linkTo } = context;
    const {
      product,
      releaseDate,
      account,
      userProductAlerts,
      createAlertRequest,
    } = props;
    const loggedIn = !!account.me;
    const userAlert = userProductAlerts.find(
      alert => alert.productId === product.id
    );
    const alertId = userAlert && userAlert.alertId;

    return (
      <div className={styles.block}>
        <button
          type="button"
          className={styles.badge.withModifier({
            'active-alert': !!alertId,
          })}
          aria-label={t('product', 'alert.create-button')}
          onClick={() => {
            if (loggedIn) {
              if (!alertId) {
                createAlertRequest({
                  productId: product.id,
                  type: 'IN_STOCK',
                });
              }
            } else {
              history.push(linkTo('productAlert', product));
            }
          }}
        >
          <div>
            <h2>{t('product', 'pre-release.new-release')}</h2>
            <small>{t('product', 'pre-release.comming-soon')}</small>
          </div>
          <button type="button">
            {t('product', 'pre-release.stock-alert-button')}
          </button>
        </button>
        <p>
          {releaseDate &&
            t('product', 'pre-release.model-information', {
              productName: product.name,
              releaseDate,
            })}
        </p>
      </div>
    );
  }
}

const { string, shape, number, object, func } = PropTypes;

PreReleaseInformation.propTypes = {
  account: shape({ me: object }),
  userProductAlerts: PropTypes.arrayOf(
    PropTypes.shape({ productId: PropTypes.number, alertId: PropTypes.number })
  ),
  product: shape({
    alertId: number,
    id: number,
    name: string,
    pathName: string,
  }),
  releaseDate: string,
  createAlertRequest: func.isRequired,
  history: object.isRequired,
};

PreReleaseInformation.defaultProps = {
  account: { me: undefined },
  userProductAlerts: [],
  product: {},
  releaseDate: undefined,
};

PreReleaseInformation.contextType = AppContext;

export default connect(
  state => ({
    account: state.areas.account,
    userProductAlerts: state.areas.sidebar.alerts.products,
  }),
  { ...alertActions }
)(withRouter(PreReleaseInformation));
